import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import  { useState } from "react";
import { useTranslation } from "react-i18next";

export const FooterView = () => {

    const [dropdown, setDropdown] = useState<boolean>(false)
    const [t,i18n] = useTranslation("global");
    // TODO lista de idiomas a codigo duro
    let idioma : any = null;
    idioma = localStorage.getItem('idioma');

    const openCloseDropdown = () =>{
        setDropdown(!dropdown);
    }

    const idiomaHandler = ((idi:any) => {
        i18n.changeLanguage(idi)      
        localStorage.setItem('idioma',idi);
        idioma = idi;
        return undefined;
    });

    return (
        <footer className="book-embed-footer">
            <div className="book-embed-footer-left">
                <div>
                    <div className="ben-translate-toggle respond-print-hide">
                <Dropdown size='lg' className="ben-item ben-translate-button capitalize dropup" direction="up" isOpen={dropdown} toggle={openCloseDropdown}>
                <DropdownToggle className="ben-item ben-translate-button capitalize">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-globe"
                                 className="icon-globe" width="14" height="14" viewBox="0 0 14 14"
                            >
                                <path
                                    d="M14 7a7 7 0 11-7-7 7 7 0 017 7zM4 7.51v1h2.41c.41 0 .59.19.59.6v1.81c0 .91.14.74-.67 1.34l-.76.58a6.09 6.09 0 005.3-1.24l-.17-.19-1.48-1.48A.65.65 0 019 9.41V7.62c0-.11-.46 0-.46-.12h-.86c-.41 0-.59-.19-.59-.59V5.66A.67.67 0 017.46 5c1.07-.67 2.54-1.35 3.62-2l.24-.15-.83-.72-2.62 1.72a.53.53 0 01-.81-.08L4.88 1.58c-.1-.09-.17-.13-.3-.07a6.13 6.13 0 00-2.64 2.27 2 2 0 00-.12.22h3.56c.44 0 .62.18.62.62v2.29c0 .4-.18.58-.58.59zm1-1V5H1.55a.24.24 0 00-.27.2 6 6 0 003 7.16.21.21 0 00.28 0 9.64 9.64 0 011-.71.87.87 0 00.44-.97 11.76 11.76 0 010-1.19H3.62c-.44 0-.62-.17-.62-.61V7.09c0-.4.18-.58.58-.59zm6.58 4.36a5.89 5.89 0 00.36-7.22c-1.11.7-2.64 1.4-3.76 2.1a.2.2 0 00-.08.12v.63h1.33a.51.51 0 01.57.58v2.05a.35.35 0 00.07.23zm-4-8l1.93-1.31a6 6 0 00-3.64-.45c.57.58 1.13 1.15 1.72 1.73z"/>
                            </svg>                   
                   {idioma === 'es' ? `${t("spanish")}` : `${t("english")}`}
                </DropdownToggle>
                <DropdownMenu size='lg'>
                    <DropdownItem style={{backgroundColor: '#0A6ECE', color: 'white'}} onClick={()=>idiomaHandler("es")}>{t("spanish")}</DropdownItem>
                    <DropdownItem style={{margin: 0}} divider/>
                    <DropdownItem style={{backgroundColor: '#0A6ECE', color: 'white'}} onClick={()=>idiomaHandler("en")} >{t("english")}</DropdownItem>
                </DropdownMenu>
            </Dropdown>

                    </div>
                </div>
            </div>

            <div className="book-embed-footer-right">
                <img
                    src="https://res.cloudinary.com/marketingpyme/image/upload/w_160,h_45,c_fill/logo_ticando.png"
                    className="img-fluid __web-inspector-hide-shortcut__" alt="TICANDO"/>
            </div>

        </footer>
    )
}
